import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const refreshToken = data => post(URL.REFRESH_TOKEN_URL, data, {skipInterceptor: true});